class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    this.isPlaying = false;
    if (this.dataset.autoplay) this.createObserver();

    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  connectedCallback() {
    this.querySelector(`[data-play-button]`)?.addEventListener("click", () => {
      this.togglePlayer();
    });
  }

  disconnectedCallback() {
    this.querySelector(`[data-play-button]`)?.removeEventListener(
      "click",
      () => {
        this.togglePlayer();
      }
    );
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        // If the element is visible
        if (entry.isIntersecting) {
          this.loadContent();
        }
      });
    });

    observer.observe(this);
  }

  togglePlayer(forcePause = false, focus = true) {
    if (this.isPlaying || forcePause) {
      this.querySelectorAll(".js-youtube").forEach((video) => {
        video.contentWindow.postMessage(
          '{"event":"command","func":"pauseVideo","args":""}',
          "*"
        );
      });
      this.querySelectorAll(".js-vimeo").forEach((video) => {
        video.contentWindow.postMessage('{"method":"pause"}', "*");
      });
      this.querySelectorAll("video").forEach((video) => video.pause());
    } else {
      if (!this.getAttribute("loaded")) {
        this.loadContent(focus);
        return;
      }

      this.querySelectorAll(".js-youtube").forEach((video) => {
        video.contentWindow.postMessage(
          '{"event":"command","func":"playVideo","args":""}',
          "*"
        );
      });
      this.querySelectorAll(".js-vimeo").forEach((video) => {
        video.contentWindow.postMessage('{"method":"play"}', "*");
      });
      this.querySelectorAll("video").forEach((video) => video.play());
    }

    this.isPlaying = !this.isPlaying;
    if (forcePause) {
      this.isPlaying = false;
    }
    this.updateStatus();
  }

  updateStatus() {
    if (this.isPlaying) {
      this.setAttribute("playing", "true");
    } else {
      this.removeAttribute("playing");
    }
  }

  playVideo(video, type) {
    if (type == "youtube") {
      if (window.YT !== undefined && window.YT.Player !== undefined) {
        this.player = new YT.Player(video, {
          videoId: this.getAttribute("data-media-id"),
          events: {
            onReady: onPlayerReady,
          },
        });

        function onPlayerReady(event) {
          event.target.playVideo();
        }
      }
    } else {
      if (window.Vimeo) {
        const player = new Vimeo(video);
        if (this.getAttribute("playing")) {
          player.pause();
        } else {
          player.play();
        }
      }
    }
  }

  pauseVideo() {
    this.isPlaying = false;
    this.updateStatus();
  }

  loadContent(focus = true) {
    //window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      if (focus) deferredElement.focus();

      if (deferredElement.nodeName == "VIDEO") {
        deferredElement.play();
      }

      if (this.dataset.id) {
        if (this.querySelector(".js-youtube") != null) {
          this.playVideo(this.querySelector(".js-youtube"), "youtube");
          this.isPlaying = true;
          this.updateStatus();
        }
        if (this.querySelector(".js-vimeo") != null) {
          this.playVideo(this.querySelector(".js-vimeo"), "vimeo");
          this.isPlaying = true;
          this.updateStatus();
        }
      } else {
        this.isPlaying = true;
        this.updateStatus();
      }
    }
  }
}
if (!customElements.get("deferred-media")) {
  customElements.define("deferred-media", DeferredMedia);
}
